import { OnboardingEntry } from "@/features/portal/components/onboarding/onboarding-entry";

/** `/portal/onboarding/:token` — validate the fill-request token, then launch
 * the wizard (or show an invalid / already-submitted landing). */
export default function OnboardingEntryPage() {
  return <OnboardingEntry />;
}
